<div class="others-product">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#prod-sriwijaya'"></app-title-page>
            </div>
            <!-- contents -->
            <div class="col-md-12 sec-contents list-circle padlist no-list" id="prod-sriwijaya">
                <div class="lane-top">
                    <div class="row mt-5">
                        <div class="col-md-12" *ngIf="dataSection[0]">
                            <h3 class="f-subtit mb-3" *ngIf="dataSection[0]?.title">{{dataSection[0]?.title}}</h3>
                            <div class="desc text-justify"
                                *ngIf="dataSection[0]?.content" 
                                [innerHTML]="dataSection[0]?.content">
                            </div>
                            <div class="bg-headline mt-4 w-100" 
                                *ngIf="dataSection[0]?.picture"
                                [ngStyle]="{'background-image' : 'url('+ apiAsset + dataSection[0]?.picture +')'}"></div>
                        </div>
                        <div class="col-md-12 mt-5" *ngIf="dataSection[1]">
                            <app-widget-image-detail [dataWidgetDet]="dataSection[1]" [order]="1"> </app-widget-image-detail>
                        </div>
                        <div class="col-md-12 mt-5" *ngIf="dataSection[2]">
                            <app-widget-image-detail [dataWidgetDet]="dataSection[2]" [order]="2"></app-widget-image-detail> 
                        </div>
                        <div class="col-md-12 mt-5" *ngFor="let data of dataSection | slice:3">
                            <h3 class="f-subtit mb-3" *ngIf="data?.title">{{ data?.title }}</h3>
                            <div class="desc text-justify"
                                 *ngIf="data?.content"
                                [innerHTML]="data?.content">
                            </div>
                            <div class="bg-headline mt-4 w-100" 
                                 *ngIf="data?.picture"
                                 [ngStyle]="{'background-image' : 'url('+ apiAsset + data?.picture +')'}"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</div>
